<template>
  <div class="desktop-only">
    <div class="desktop-only__inner">
      <h2 class="desktop-only__title">Best on desktop</h2>
      <p class="desktop-only__body">{{ message }}</p>
      <button v-if="backLabel" class="primaryButton" @click="$emit('back')">
        {{ backLabel }}
      </button>
    </div>
  </div>
</template>

<script>
// Generic full-screen notice for steps that aren't available on touch devices
// (artwork creation, panels scene editing). Keep the copy short and non-specific
// so it reads sensibly wherever it's shown.
export default {
  name: 'DesktopOnlyNotice',
  props: {
    message: {
      type: String,
      default: 'Creating and editing isn’t available on mobile. Open the Creator on a desktop to continue.'
    },
    backLabel: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '../styles/main.styl'

.desktop-only
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  display: flex
  align-items: center
  justify-content: center
  background: #fff
  z-index: $modal-z-index
  padding: 32px
  padding-top: calc(32px + env(safe-area-inset-top))
  text-align: center
  box-sizing: border-box

  &__inner
    max-width: 340px

  &__title
    margin: 0 0 12px
    color: #333

  &__body
    color: #666
    line-height: 1.5
    margin: 0 0 20px
</style>
